import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export const RequiredValidator = (control: AbstractControl): ValidationErrors | null => {
  const nativeValidationResult: ValidationErrors | null = Validators.required(control);

  if (nativeValidationResult) {
    return nativeValidationResult;
  }

  if (typeof control.value === 'string' && (control.value || '').trim().length === 0) {
    return { required: true };
  }

  return null;
};
